import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { OrgSelectionProvider } from "@/context/org-selection";
import { QueryProvider } from "@/providers/query-provider";
import { AppRoutes } from "@/routes";
import "@/styles/globals.css";

// The Shadow Realm authenticates against the Shadow Realm ORGANIZATION's own
// Kinde custom domain, which is what scopes the session to that organization —
// no org code is passed anywhere. The audience is the app's own Kinde API, so
// these tokens are rejected by the customer routes and vice versa.
const KINDE_CLIENT_ID = import.meta.env.VITE_KINDE_CLIENT_ID || "";
const KINDE_DOMAIN = import.meta.env.VITE_KINDE_DOMAIN || "";
const KINDE_AUDIENCE = import.meta.env.VITE_KINDE_AUDIENCE || "";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<KindeProvider
			audience={KINDE_AUDIENCE || undefined}
			clientId={KINDE_CLIENT_ID}
			domain={KINDE_DOMAIN}
			logoutUri={window.location.origin}
			redirectUri={window.location.origin}
		>
			<QueryProvider>
				<BrowserRouter>
					<OrgSelectionProvider>
						<AppRoutes />
					</OrgSelectionProvider>
				</BrowserRouter>
			</QueryProvider>
		</KindeProvider>
	</StrictMode>,
);
